export default {
  base_url: process.env.REACT_APP_BASE_URL,
  api_key: process.env.REACT_APP_API_KEY,
}
